import { generateClassName } from '@klv/shared/utils/functions';
import { Wrapper } from '@klv/utils/wrapper';

import * as styles from './styles/exploreMore.module.scss';

import type { IExploreMore } from './types';

export const ExploreMore = ({
  backgroundColor,
  customPadding = { customPaddingTop: 'md', customPaddingBottom: 'md' },
  fadeIn,
  headline,
  subtext,
  columns,
}: IExploreMore) => (
  <Wrapper
    className={styles.exploreMore}
    backgroundColor={backgroundColor}
    contained={true}
    inlinePadding={true}
    customPadding={customPadding}
    fadeIn={fadeIn ? 0.25 : undefined}
    grid={true}
  >
    <>
      <div className={styles.exploreMoreContent}>
        {headline && <div className={generateClassName(['h3', 'semibold'])}>{headline}</div>}
        {subtext && <div className={generateClassName(['p2'])} dangerouslySetInnerHTML={{ __html: subtext }} />}
      </div>
      {columns?.map((column) => (
        <div key={JSON.stringify(column)} className={styles.exploreMoreColumn}>
          {(column.column ?? []).map((link) => (
            <a
              key={JSON.stringify(link)}
              href={link.url}
              target={link.openInNewTab ? '_blank' : '_self'}
            >
              {link.label}
            </a>
          ))}
        </div>
      ))}
    </>
  </Wrapper>
);

